import { GemecoValidateAddressHandlerType } from "@gemeco/Handlers/GemecoValidateAddress";
import { makeHandlerChainAwaitable, replaceInChain } from "@insite/client-framework/HandlerCreator";
import validateAddress, { AddressErrors } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import {
    chain,
    ValidateAddress,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/ValidateShippingAddressForm";

export type HandlerType = Parameters<typeof ValidateAddress>[0];

replaceInChain(chain, ValidateAddress, ModifiedValidateAddress);

async function ModifiedValidateAddress(props: HandlerType) {
    const awaitableValidate = makeHandlerChainAwaitable<Parameters<typeof validateAddress>[0], AddressErrors>(
        validateAddress,
    );
    const byPassAddressValidation =
        (props.parameter as unknown as GemecoValidateAddressHandlerType)?.byPassAddressValidation ?? false;
    props.formErrors = await awaitableValidate({
        address: props.parameter.address,
        validationRules: props.parameter.validation!,
        addressFieldDisplayCollection: props.parameter.fieldDisplay,
        isOneTimeAddress: props.parameter.address.oneTimeAddress,
        byPassAddressValidation,
    } as GemecoValidateAddressHandlerType)(props.dispatch, props.getState);
}